import React, { useEffect, useRef } from "react";
import Jayant from "assets/img/Jayant.mp3";

function IndexHeader() {
  const audioRef = useRef(null); // Ref to the audio element

  useEffect(() => {
    const handleScroll = () => {
      const audioElement = audioRef.current;

      // Check if the audio is not already playing and the user has scrolled to a certain point
      if (!audioElement.paused || window.scrollY > 100) {
        audioElement.play(); // Start playing the music
        audioElement.volume = 0.04; // Adjust volume
        window.removeEventListener("scroll", handleScroll); // Remove the scroll event listener after starting playback
      }
    };

    window.addEventListener("scroll", handleScroll); // Add scroll event listener

    return () => {
      window.removeEventListener("scroll", handleScroll); // Cleanup: Remove the scroll event listener when the component unmounts
    };
  }, []); // Run the effect only once when the component mounts

  return (
    <>
      <div className="page-header section-dark">
        <div>
          <video autoPlay loop muted>
            <source src={require("assets/img/TradelineSlideshowWebsite.mp4")} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div>
            <audio ref={audioRef} src={Jayant} /> {/* Audio element */}
          </div>
        </div>
      </div>
    </>
  );
}

export default IndexHeader;
